import React, { FC, useRef } from 'react'
import { Layout } from 'components/Layout'
import { OrderTemplate } from 'components/Templates'
import { TopHeadline } from 'components/Typography'
import { addDays, isAfter, isSameDay } from 'date-fns'
import { dateToString, parseToDate } from 'lib/helper'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { useHeadline } from 'hooks/order'
import { push } from 'connected-react-router'

const Order: FC = () => {
  const headingRef = useRef<HTMLHeadingElement>(null)
  const dispatch = useDispatch()
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const date = /\/order\/.+/.test(pathname) ? pathname.split('/order/')[1] : undefined
  const currentDate = date ? parseToDate(date) : new Date()
  const isToday = isSameDay(currentDate, new Date())
  const isFuture = isAfter(currentDate, new Date())
  const headline = useHeadline(currentDate)
  const handlePrevDate = () => {
    const prevDate = addDays(currentDate, -1)
    dispatch(push(`/order/${dateToString(prevDate)}`))
  }
  const handleNextDate = () => {
    const nextDate = addDays(currentDate, 1)
    dispatch(push(`/order/${dateToString(nextDate)}`))
  }

  return (
    <Layout
      customHeadline={
        <TopHeadline
          ref={headingRef}
          headline={headline}
          iconPath="/icon/white/schedule.svg"
          prevIcon={<img src="/icon/arrow_prev.svg" alt="前の日付へ" onClick={handlePrevDate} />}
          nextIcon={<img src="/icon/arrow_next.svg" alt="次の日付へ" onClick={handleNextDate} />}
          size="small"
        />
      }
      headingRef={headingRef}
      title={'本日お渡しする注文'}
    >
      <OrderTemplate currentDate={currentDate} date={date} isFuture={isFuture} isToday={isToday} pathname={pathname} />
    </Layout>
  )
}

export default Order
